import { lazy, Suspense } from 'react';
import { AuthGuard } from '@emfood/shared';
import { Outlet, createRoute } from '@tanstack/react-router';

import { paths } from 'src/routes/paths';

import { ROLES } from 'src/api/roles-config';
import DashboardLayout from 'src/layouts/dashboard';

import { SplashScreen, LoadingScreen } from 'src/components/loading-screen';

import { rootRoute } from './root';

const Reporting = lazy(() => import('src/sections/reporting/view'));

const reportingRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: 'reporting',
  component: () => (
    <AuthGuard
      splashScreen={<SplashScreen />}
      loginPath={paths.auth.jwt.login}
      pathOnAuthProblem={paths.auth.jwt.login}
      allowedRoles={[
        ROLES.ADMIN,
        ROLES.DISTRIBUTOR_ADMIN,
        ROLES.PRODUCER_ADMIN,
        ROLES.BUYER_ADMIN,
        ROLES.ENTEGRA_USER,
      ]}
      insufficientRolePath="/insufficient-role"
    >
      <DashboardLayout>
        <Suspense fallback={<LoadingScreen />}>
          <Outlet />
        </Suspense>
      </DashboardLayout>
    </AuthGuard>
  ),
});

const reportingIndexRoute = createRoute({
  getParentRoute: () => reportingRoute,
  path: '/',
  component: Reporting,
});

export const reportingRouteTree = reportingRoute.addChildren([reportingIndexRoute]);
